import styled from 'styled-components';
import { config } from '../../../../components/dashboards/config';

export default styled.div`
  width: calc(100% - ${config.PADDING * 2}px);
  margin-left: ${config.PADDING}px;
  
  .loading-cont {
    height: 400px;
    position: relative;
  }

  &.clickable {
    cursor: pointer;
  }

  .ant-table-row-level-1 {
    background: #FAFAFA;
    border: 0px;

    td {
      border: 0px;
    }
  }

  .ant-empty-normal {
    min-height: 276px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .status-cont {
    display: flex;

    .ant-tag {
      width: 80px !important;
      text-align: center;

      &.tag-in-progress {
        color: #2F54EB;
        border-color: #2F54EB;
        background: #F0F5FF;
      }
    }
  }

  .ant-table-cell {
    padding: 9px
  }

  .ant-table-container {
    height: 400px;
    overflow-y: auto;

    .ant-table-thead {
      .ant-table-cell {
        background: #F5F5F5 !important;
      }
    }
  }

  .comment-icon {
    font-size: 15px;
    margin-top: 1px;
    color: #909090;

    &.active {
      color: var(--color-primary-70);
    }
  }

  .ant-table-content {
    border-left: 1px solid #F0F0F0;
    border-right: 1px solid #F0F0F0;
    border-top: 1px solid #F0F0F0;
  }

  .status-tag {
    svg {
      margin-top: -4px;
    }
  }

  .content-centered {
    display: flex;
    justify-content: center;
  }

  .expand-cont {
    display: flex;
    gap: 5px;
    cursor: pointer;
    color: #909090;

    svg {
      margin-top: 4px;
    }

    label {
      margin-bottom: 0px;
      cursor: pointer;
      text-decoration-line: underline;
    }

    &.is-active {
      label {
        color: #001529;
      }

      svg {
        color: var(--color-primary-70);
      }
    }
  }

  .submission-date {
    display: flex;
    justify-content: space-between;

    label { 
      font-weight: 500;
      margin-bottom: 0px;
      font-size: 14px;
    }
  }

  .ant-table-cell-with-append {
    padding: 0px 4px;
    position: relative;
  }

  .expanded-row-container {
    .line {
      width: 2px;
      position: absolute;
      background: #B5B5B5;
      height: 100%;
      top: 0px;
      left: 25px;

      &.last {
        height: 50%;
      }
    }

    .left-line {
      width: 20px;
      position: absolute;
      background: #B5B5B5;
      height: 2px;
      top: 50%;
      left: 25px;
    }
  }

  .expanded-table-cell {
    .ant-table-cell {
      padding: 0px;
    }
  }

  .active-row {
    td {
      background: #DCEEFF !important;
    }
  }
`;
